import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from '../src/components/Home';
import Readmore from '../src/components/Readmore';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/readmore" element={<Readmore />} />

      </Routes>
    </Router>
  );
};

export default App;
